import React, { ReactNode } from "react";

interface Props {
  children?: ReactNode;
}

export default function InlineBox(props: Props): JSX.Element {
  return <div className="inline-box">{props.children}</div>;
}
